<script>
  import { Line, mixins } from 'vue-chartjs';

  export default {
    extends: Line,
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    data: function () {
      return {
        chartOptions: {
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Continue vs 3bet percentage',
              },
            }],
            yAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'EV (bb)',
              },
            }],
          },
        },
      };
    },
    mounted: function () {
      this.renderChart(this.chartData, this.chartOptions);
    },
  };
</script>

<style lang="scss" scoped>
  .chartjs-render-monitor {
    height: calc(100vh - 340px) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/three-bet-cbet-explorer/three-bet-cbet-explorer-graph.vue